import { addEdge } from '@xyflow/react';
import { getGuid } from '../../../helpers/utility';
import { FormJourney, TemplateEditorPayload, TemplateState } from '../../templateeditor-types';
import { JourneyNodeType } from '../../../helpers/constants';
import { setIn } from '../../../helpers/helpers';

export function getIntialFormJourneyState(state: TemplateState): TemplateState {
  const startNodeId = getGuid();
  const endNodeId = getGuid();
  state.journey = {
    ui: {
      nodes: [
        { id: startNodeId, position: { x: 0, y: 0 }, data: {}, type: 'start', deletable: false },
        { id: endNodeId, position: { x: 0, y: 500 }, data: {}, type: 'end', deletable: false }
      ],
      edges: addEdge(
        {
          source: startNodeId,
          target: endNodeId,
          sourceHandle: startNodeId,
          targetHandle: endNodeId
        },
        []
      )
    },
    states: [
      {
        id: startNodeId,
        type: JourneyNodeType.Start,
        status: 'Draft',
        nextNodeId: endNodeId
      },
      {
        id: endNodeId,
        type: JourneyNodeType.End,
        status: 'Complete'
      }
    ]
  };

  return state;
}

export function updateSelectedJourneyNodes(state: TemplateState, payload: Partial<TemplateEditorPayload>): TemplateState {
  const { nodes } = payload;
  state.selection = { nodeIds: nodes.map((x) => x.id) };

  return state;
}

export function updateJourneyNodes(state: TemplateState, payload: Partial<TemplateEditorPayload>): TemplateState {
  const { nodes } = payload;

  if (!state.journey) {
    state.journey = { ui: { nodes }, states: [] };
  } else {
    state.journey.ui.nodes = nodes;
  }

  return state;
}

export function updateJourneyEdges(state: TemplateState, payload: Partial<TemplateEditorPayload>): TemplateState {
  const { edges } = payload;

  if (!state.journey) {
    state.journey = { ui: { edges }, states: [] };
  } else {
    state.journey.ui.edges = edges;
  }

  return state;
}

export function updateJourneyNodeProperty(state: TemplateState, payload: Partial<TemplateEditorPayload>): TemplateState {
  const { keyPath, value } = payload;
  setIn(state, keyPath, value);
  return state;
}

export function addJourneyStates(state: TemplateState, payload: Partial<TemplateEditorPayload>): TemplateState {
  const { nodes, states, edges } = payload;
  state.journey.ui.nodes = state.journey.ui.nodes.concat(nodes);
  state.journey.states = state.journey.states.concat(states);

  if (!!edges) {
    state.journey.ui.edges = state.journey.ui.edges.concat(edges);
  }

  return state;
}

export function deleteJourneyStates(state: TemplateState, payload: Partial<TemplateEditorPayload>): TemplateState {
  const { ids } = payload;

  const newJourney: FormJourney = {
    ui: {
      nodes: [...state.journey.ui.nodes],
      edges: [...state.journey.ui.edges]
    },
    states: [...state.journey.states]
  };

  for (const id of ids) {
    removeNode(id, newJourney);
  }

  state.journey = newJourney;
  return state;
}

function removeNode(id: string, journey: FormJourney) {
  const state = journey.states.find((x) => x.id === id);
  if (!state || state.type === JourneyNodeType.Start || state.type === JourneyNodeType.End) {
    return;
  }

  if (state.type === JourneyNodeType.Approval) {
    //Delete outcomes and associated edges
    for (const outcomeId of journey.states.filter((x) => x.parentId === id).map((x) => x.id)) {
      removeNode(outcomeId, journey);
    }
  }

  journey.ui.nodes = journey.ui.nodes.filter((x) => x.id !== id);
  journey.ui.edges = journey.ui.edges.filter((x) => x.source !== id && x.target !== id);
  journey.states = journey.states.filter((x) => x.id !== id);
}
